import React from 'react';
import { Check, Circle, ArrowLeft, ArrowRight, Eye } from 'lucide-react';

const ChallengeList = ({ challenges, completedIds, currentIndex, translations }) => {
  const getChallengeIcon = (instruction) => {
    const iconMap = {
      'turnLeft': ArrowLeft,
      'turnRight': ArrowRight,
      'blinkTwice': Eye
    };
    return iconMap[instruction] || Circle;
  };

  return (
    <div className="space-y-3">
      {challenges?.map((challenge, idx) => {
        const isCompleted = completedIds.includes(challenge.id);
        const isActive = idx === currentIndex;
        const ChallengeIcon = getChallengeIcon(challenge.instruction);
        
        return (
          <div
            key={challenge.id}
            className={`
              px-5 py-4 rounded-xl border-2 
              flex items-center gap-4
              transition-all duration-200
              ${isCompleted ? 'bg-accent-green/5 border-accent-green' : ''}
              ${isActive ? 'bg-accent-golden/0 border-accent-green shadow-lg shadow-accent-green/10' : ''}
              ${!isCompleted && !isActive ? 'border-accent-green/20 bg-transparent' : ''}
            `}
          >
            {/* Status Icon */}
            <div className="flex-shrink-0">
              {isCompleted ? (
                <div className="w-10 h-10 rounded-full bg-accent-green flex items-center justify-center">
                  <Check className="text-white" size={20} strokeWidth={3} />
                </div>
              ) : isActive ? (
                <div className="w-10 h-10 rounded-full bg-accent-golden flex items-center justify-center">
                  <ChallengeIcon className="text-primary-black" size={20} strokeWidth={2.5} />
                </div>
              ) : (
                <div className="w-10 h-10 rounded-full border-2 border-accent-green/30 flex items-center justify-center">
                  <Circle className="text-accent-green/40" size={18} />
                </div>
              )}
            </div>

            {/* Challenge Text */}
            <span className={`
               flex-1 text-sm
              ${isActive ? 'text-accent-white' : isCompleted ? 'text-accent-green' : 'text-text-light/70'}
            `}>
              {translations?.[challenge.instruction] || challenge.text}
            </span>

            {/* Step Number */}
            <span className={`
              text-sm font-bold px-3 py-1.5 rounded-lg min-w-[2.5rem] text-center
              ${isCompleted ? 'bg-accent-green text-white' : ''}
              ${isActive ? 'bg-accent-golden text-primary-black' : ''}
              ${!isCompleted && !isActive ? 'bg-accent-green/10 text-accent-green/50' : ''}
            `}>
              {idx + 1}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ChallengeList;